import { useEffect, useState } from 'react'
import { useRouteMatches } from 'hooks/useRouteMatches'
import { alphabeticalSort } from 'shared'
import { UseMiscellaneousHeaderActionsOptions } from './types'

export function useMiscellaneousHeaderActions<T extends object, U>({
  actions,
  records,
  rowKey,
  defaultSort,
  setExpandedRowKeys,
  setDataSource,
}: UseMiscellaneousHeaderActionsOptions<T, U>) {
  const [payItemId, setPayItemId] = useState<string | undefined>()
  useEffect(() => {
    setPayItemId(actions?.header?.payItems?.globalId)
  }, [actions?.header?.payItems?.globalId])
  const { param } = useRouteMatches()
  const [deepLinkValue, setDeepLinkValue] = useState<string | undefined>()
  useEffect(() => {
    const filterPayItems = actions?.header?.payItems?.onFilter

    const matched = param('deepLink')
    if (deepLinkValue !== matched) setDeepLinkValue(matched)

    if (records)
      setDataSource(() => {
        const filtered = records.filter((record) => {
          if (payItemId && filterPayItems)
            return filterPayItems(payItemId, record)

          if (!!matched && !!actions?.header?.deepLinkKey) {
            let found = false
            if (typeof actions.header.deepLinkKey === 'function') {
              const value = actions.header.deepLinkKey(record)
              const values = Array.isArray(value) ? value : [value]
              found = values.some((value) => value?.toString() === matched)
            } else found = `${record[actions.header.deepLinkKey]}` === matched
            const key =
              typeof rowKey === 'function'
                ? rowKey(record)
                : String(record[rowKey])
            if (found) setExpandedRowKeys([key])
            return found
          }

          return true
        })
        if (defaultSort)
          filtered.sort(
            typeof defaultSort === 'function'
              ? defaultSort
              : alphabeticalSort(defaultSort)
          )
        return filtered
      })
  }, [
    actions?.header,
    actions?.header?.deepLinkKey,
    actions?.header?.payItems,
    deepLinkValue,
    defaultSort,
    param,
    payItemId,
    records,
    rowKey,
    setExpandedRowKeys,
    setDataSource,
  ])

  return {
    payItems:
      !param('deepLink') && actions?.header?.payItems
        ? {
            ...(actions.header.payItems ?? {}),
            globalId: payItemId,
            onChange: (globalId?: string) => setPayItemId(globalId),
          }
        : undefined,
    deepLink: {
      deepLinkKey: actions?.header?.deepLinkKey,
      value: deepLinkValue,
    },
  }
}
